<script>
  import TitleLink from './TitleLink.svelte';
  import Login from './Login.svelte';
  import AppTable from './AppTable.svelte';
  import LogTable from './LogTable.svelte';
  import SessionsTable from './SessionsTable.svelte';
  import HelpMenu from './HelpMenu.svelte';
  import api from './api.js';
  import {shortID} from './util.js';

  const params = new URLSearchParams(window.location.search);
  const sid = params.get('sid');
  const appName = params.get('app');

</script>

<svelte:window on:keydown={handleKeydown}/>

<main>
  {#if !api.getToken()}
    <div class='tbar'>
      <TitleLink text='' href='/' />
    </div>
    <Login />
  {:else}
    <HelpMenu />
    {#if sid}
      <div class='tbar'>
        <TitleLink text='apps' href='/' />
        <TitleLink text={appName} href={`?app=${appName}`} />
        <TitleLink text={shortID(sid)} href={`?app=${appName}&sid=${sid}`} />
      </div>
      <LogTable {sid} />
    {:else if appName}
      <div class='tbar'>
        <TitleLink text='apps' href='/' />
        <TitleLink text={appName} href={`?app=${appName}`} />
      </div>
      <SessionsTable {appName} />
    {:else}
      <div class='tbar'>
        <TitleLink text='apps' href='/' />
      </div>
      <AppTable />
    {/if}
  {/if}
</main>

<style>
  main {
    background-color: rgb(11, 12, 13);
    padding-bottom: 4rem;
  }
  .tbar {
    display: flex;
    margin-top: 0.1rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }
</style>
